<nz-sider nzTheme="light" nzCollapsible [nzCollapsed]="isCollapsed()" [nzTrigger]="null" [nzCollapsedWidth]="50">

  <div class="logo-item">
    <span class="anticon">
      <img src="/assets/icons/xwai-icon-cropped.png" alt="XWAI" />
    </span>
    @if (!isCollapsed()) {
      <span>XWAI</span>
    }

    <!-- Hidden when locked: embedded in the ai-panel, the panel's own
         expand button is the only toggle — this rail isn't independently interactive. -->
    @if (!isLocked()) {
      <nz-icon (click)="collapsed.set(!collapsed())" nz-tooltip
        [nzTooltipTitle]="collapsed() ? 'Expand sidebar' : 'Collapse sidebar'" nzTooltipPlacement="right"
        class="trigger" [ngClass]="collapsed() ? 'trigger-collapsed' : ''"
        [nzType]="collapsed() ? 'menu-unfold' : 'menu-fold'">
      </nz-icon>
    }
  </div>

  <!-- A real button, not a menu item: skips ant's menu selection/collapse
       machinery entirely, so it needs none of the workarounds that fights it. -->
  <div class="actions" style="justify-content: center;">
    <button nz-button nzSize="small" nz-tooltip nzTooltipTitle="New chat" nzTooltipPlacement="right"
      class="new-chat-item" (click)="startNewChat()">
      <nz-icon nzType="plus" nzTheme="outline" />
      @if (!isCollapsed()) {
        <span class="header-btn-label">New chat</span>
      }
    </button>
  </div>

  @if (!isCollapsed()) {
  <div class="conversation-groups">
    <nz-collapse nzGhost class="conversation-collapse recent-collapse">
      <nz-collapse-panel nzHeader="Recent" [nzActive]="true">
        <ul nz-menu nzTheme="light" nzMode="inline">
          @for (convo of myConversations(); track $index) {
          <li nz-menu-item nz-tooltip [nzTooltipTitle]="convo.name" nzTooltipPlacement="right"
            [nzTooltipMouseEnterDelay]="0.7" (click)="setActiveConvo(convo)" [nzSelected]="convo.id == activeConversation()?.id">
            <nz-icon nzType="message" nzTheme="outline" />
            <span style="display: flex; justify-content: space-between;">
              <span>
                {{ convo.name }}
              </span>
              <span class="convo-options" nz-dropdown [nzDropdownMenu]="convoMenu" nzTrigger="click" (click)="$event.stopPropagation()">
                <nz-icon nzType="more" nzTheme="outline" />
              </span>

              <nz-dropdown-menu #convoMenu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="openEditModal(convo)">Edit</li>
                  <li nz-menu-item nzDanger (click)="deleteConversation(convo)">Delete</li>
                </ul>
              </nz-dropdown-menu>

            </span>
          </li>
          } @empty {
          <li class="conversations-empty">No conversations yet — save a new chat and it will show up here.</li>
          }
        </ul>
      </nz-collapse-panel>
    </nz-collapse>

    <nz-collapse nzGhost class="conversation-collapse public-collapse">
      <nz-collapse-panel nzHeader="Public" [nzActive]="true">
        <ul nz-menu nzTheme="light" nzMode="inline">
          @for (convo of otherConversations(); track $index) {
          <li nz-menu-item nz-tooltip [nzTooltipTitle]="convo.name" nzTooltipPlacement="right"
            [nzTooltipMouseEnterDelay]="0.7" (click)="setActiveConvo(convo)" [nzSelected]="convo.id == activeConversation()?.id">
            <nz-icon nzType="message" nzTheme="outline" />
            <span>
              {{ convo.name }}
            </span>
          </li>
          } @empty {
          <li class="conversations-empty">No one has saved a public conversation yet</li>
          }
        </ul>
      </nz-collapse-panel>
    </nz-collapse>
  </div>
  }
  <div class="actions" style="justify-content: center;">
    <button nz-button nzSize="small" nz-tooltip nzTooltipTitle="Image Flipper" nzTooltipPlacement="top"
      (click)="toggleImageFlipper()">
      <nz-badge [nzCount]="imageCount()" nzSize="small">
        <nz-icon nzType="picture" nzTheme="outline" />
      </nz-badge>
      @if (!isCollapsed()) {
        <span class="header-btn-label">Image Flipper</span>
      }
    </button>
  </div>

  <div class="actions">
    <button nz-button nzSize="small" nz-tooltip nzTooltipTitle="About XWAI" nzTooltipPlacement="top" (click)="guideOpen.set(true)">
      <nz-icon nzType="question" nzTheme="outline" />
      @if (!isCollapsed()) {
        <span class="header-btn-label">Guide</span>
      }
    </button>

    <!-- can only be saved if threadId is present. this also check if its an active conversation, cause in that scenario its gonna be an update and not a save-->
    @if(threadId() && !activeConversation()){
      <!-- the dot marks retuned visualizations that are only persisted on save -->
      <nz-badge [nzDot]="unsavedVizEdits()">
        <button nz-button nzSize="small" nz-tooltip [nzTooltipTitle]="saveTooltip()" nzTooltipPlacement="top"
          [disabled]="messages().length <= 1" (click)="openSaveModal()">
          <nz-icon nzType="save" nzTheme="outline"></nz-icon>
          @if (!isCollapsed()) {
            <span class="header-btn-label">Save</span>
          }
        </button>
      </nz-badge>
    }@else if (threadId() && activeConversation()) {
      <!-- the case when its an old but active conversation. means the thread ID is avaialble, so we let the user 'update' the conversation -->
      <nz-badge [nzDot]="unsavedVizEdits()">
        <button nz-button nzSize="small" nz-tooltip [nzTooltipTitle]="updateTooltip()" nzTooltipPlacement="top"
          (click)="update(activeConversation()!)">
          <nz-icon nzType="save" nzTheme="outline"></nz-icon>
          @if (!isCollapsed()) {
            <span class="header-btn-label">Update</span>
          }
        </button>
      </nz-badge>
    }
  </div>
</nz-sider>

<app-xwai-modal [(visible)]="saveModalVisible" title="Save Conversation" [showDefaultFooter]="false">
  <form nz-form nzLayout="vertical" [formGroup]="saveForm" (ngSubmit)="save()">
    <nz-form-item>
      <nz-form-label nzRequired>Name</nz-form-label>
      <nz-form-control nzErrorTip="Please enter a name">
        <input type="text" nz-input formControlName="name">
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label>Description</nz-form-label>
      <nz-form-control>
        <textarea nz-input formControlName="description"></textarea>
      </nz-form-control>
    </nz-form-item>
    <label nz-checkbox formControlName="isPublic">Is the conversation public?</label>

    <div class="modal-actions">
      <button nz-button type="button" (click)="saveModalVisible.set(false)">Cancel</button>
      <button nz-button nzType="primary" type="submit" [disabled]="saveForm.invalid">Save</button>
    </div>
  </form>
</app-xwai-modal>

<app-xwai-modal [(visible)]="editModalVisible" title="Edit Conversation" [showDefaultFooter]="false">
  <form nz-form nzLayout="vertical" (ngSubmit)="saveEditedConversation()">
    <nz-form-item>
      <nz-form-label nzRequired>Name</nz-form-label>
      <nz-form-control>
        <input nz-input name="editName" [(ngModel)]="editName" />
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label>Description</nz-form-label>
      <nz-form-control>
        <textarea nz-input name="editDescription" [(ngModel)]="editDescription"></textarea>
      </nz-form-control>
    </nz-form-item>
    <label nz-checkbox name="editPublic" [(ngModel)]="editPublic">Is the conversation public?</label>

    <div class="modal-actions">
      <button nz-button type="button" (click)="editModalVisible.set(false)">Cancel</button>
      <button nz-button nzType="primary" type="submit" [disabled]="!editName.trim()">Save</button>
    </div>
  </form>
</app-xwai-modal>

<!-- Walkthrough / onboarding guide -->
<nz-drawer [nzVisible]="guideOpen()" nzPlacement="right" nzWidth="min(640px, 96vw)" nzTitle="How XWAI works"
  [nzClosable]="true" (nzOnClose)="guideOpen.set(false)">
  <ng-container *nzDrawerContent>
    <app-xwai-guide></app-xwai-guide>
  </ng-container>
</nz-drawer>

<app-xwai-image-flipper></app-xwai-image-flipper>